import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { Media } from '../../../../../theme/Media.js';
import { Select } from '../../../../Form/Select/index.js';
import { dataTableSection } from '../../constants.js';
import { useTableContext } from '../../context.js';
import { Info } from '../Info/index.js';
import { PageInfo } from '../PageInfo/index.js';
import { PaginationControls } from '../PaginationControls/index.js';
import { paginationPresetDefault, paginationPresetReduced } from './constants.js';
import { PageInfoWrapper, PaginationWrapper } from './styled.js';
export const Pagination = memo(function Pagination({ className, info, pagination, isLoading, dataTestId }) {
    const { compact } = useTableContext();
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const selectedPerPage = useMemo(() => ({ label: String(pagination.perPage), value: pagination.perPage }), [pagination.perPage]);
    const isReducedPaginationPreset = useMemo(() => !!paginationPresetReduced.find((option) => option.value === pagination.perPage), [pagination.perPage]);
    const handleSetPerPage = useCallbackRef((option) => {
        // react-select fires onChange even when the already-selected option is picked again. Without this
        // guard that no-op silently sent the reader back to page 1.
        if (option && option.value !== pagination.perPage) {
            pagination.setPerPage(option.value);
            pagination.setPage(0);
        }
    });
    const nextPage = useCallbackRef(() => {
        pagination.setPage((prev) => prev + 1);
    });
    const prevPage = useCallbackRef(() => {
        pagination.setPage((prev) => prev - 1);
    });
    if (!isLoading && info.total <= pagination.perPage) {
        return _jsx(Info, { total: info.total, isLoading: isLoading });
    }
    return (_jsxs(PaginationWrapper, { className: className, $compact: compact, ...dataTableSection, "data-testid": dataTestId, children: [!isMobile && (_jsx("div", { "data-testid": 'per-page-dropdown', children: _jsx(Select, { options: isReducedPaginationPreset ? paginationPresetReduced : paginationPresetDefault, value: selectedPerPage, onChange: handleSetPerPage, menuPlacement: 'auto', "data-testid": 'select-op' }) })), _jsx(PageInfoWrapper, { children: _jsx(PageInfo, { dataTestId: 'from-to-total-pagination', ...info, isLoading: isLoading }) }), _jsx(PaginationControls, { page: pagination.page, perPage: pagination.perPage, total: info.total, onPrev: prevPage, onNext: nextPage })] }));
});
export { usePageInfo } from './usePageInfo.js';
export { usePagination } from './usePagination.js';
